import { ReactNode } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCertificate } from '@fortawesome/pro-solid-svg-icons'
import { dateParse } from 'helpers/date.helper'
import Button from 'design-system/button'
import { ButtonSizes } from 'design-system/button/src/resources/ButtonAttributes.enum'
import { createRouteCertificateGenerate } from 'enum/routes'
import { CertificateType } from 'enum/certificateType.enum'
import styles from './MyCertificates.module.scss'
import { CertificatesTypes, prefix } from './constants'
import { Certificate } from './types'
import GroupTooltip from './components/GroupTooltip'

export const TableRow = ({
  row,
  onDesktop,
}: {
  onDesktop: boolean
  row: Certificate
}) => {
  const { t } = useTranslation()

  const format = (value) => dateParse(value, 'dd-MM-yyyy')

  const internal = row.type === CertificatesTypes.internal ? row : undefined
  const id = internal?.certificate?.id || row.id
  const courseId = internal?.courseId

  const certificate = internal?.certificate
  const certificateType = certificate?.certificateType

  let date = format(row.createdAt)
  if (row.type === CertificatesTypes.external) {
    const endDate = row.endDate && format(row.endDate)
    if (endDate) date = endDate
  }

  const url =
    row.type === CertificatesTypes.external
      ? row.url
      : (id &&
          createRouteCertificateGenerate({
            certificateId: id.toString(),
            courseId: (courseId || 0).toString(),
          })) ||
        undefined

  let suffix: ReactNode
  if (internal) {
    if (certificateType === CertificateType.individual) {
      const courseName = internal?.course?.name
      suffix = `(${courseName})`
    }
    if (certificateType === CertificateType.group) {
      const courses = certificate?.certificateCourseAttributes
      if (courses)
        suffix = (
          <GroupTooltip
            placement="top"
            title={
              <div>
                {courses.map(({ name }) => (
                  <div key={name}>{name}</div>
                ))}
              </div>
            }
          >
            <span>+{courses.length}</span>
          </GroupTooltip>
        )
    }
  }
  return (
    <tr>
      <td>
        <div
          className={classNames(styles.nameColumn, 'd-flex align-items-center')}
        >
          <FontAwesomeIcon icon={faFileCertificate} className="icon" />
          {row.name} {suffix && <span className="ml-1">{suffix}</span>}
        </div>
      </td>
      {onDesktop && (
        <td>
          {internal &&
            (certificateType === CertificateType.individual
              ? t(`${prefix}.types.individual`)
              : t(`${prefix}.types.group`))}
        </td>
      )}
      {onDesktop && <td>{t(`${prefix}.sources.${row.type}`)}</td>}
      {onDesktop && <td>{date}</td>}
      <td className={styles.option}>
        <Button
          size={ButtonSizes.ExtraSmall}
          className={`${styles.downloadButton}`}
          href={url}
          target="_blank"
          component="a"
        >
          {t(`${prefix}.table.download`)}
        </Button>
      </td>
    </tr>
  )
}
